import { render, staticRenderFns } from "./MachineParcelSplitPopup.vue?vue&type=template&id=10ba8d0f&scoped=true"
import script from "./MachineParcelSplitPopup.vue?vue&type=script&lang=js"
export * from "./MachineParcelSplitPopup.vue?vue&type=script&lang=js"
import style0 from "./MachineParcelSplitPopup.vue?vue&type=style&index=0&id=10ba8d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba8d0f",
  null
  
)

export default component.exports